import React from 'react'
import ProfileDetailsContent from './ProfileDetailsContent'

const ProfileDetailsBody = () => {
    return (
        <div className="view-qualities folded router-view-container">
            <ProfileDetailsContent />
        </div>
    )
}

export default ProfileDetailsBody